<template>
    <div
        v-editable="blok"
        class="youtube-embed"
    >
        <ScriptYouTubePlayer
            v-if="videoId"
            :video-id="videoId"
            :player-vars="{ autoplay: 1 }"
            :title="blok.title"
            trigger="click"
            class="youtube-embed__player"
            @state-change="onStateChange"
        />
    </div>
</template>

<script setup>
const { blok } = defineProps(['blok'])

const { capture } = useTracking()

// blok.url is the full embed URL (https://www.youtube.com/embed/<id>) as entered
// in Storyblok; ScriptYouTubePlayer wants the bare id.
const videoId = computed(() => {
    const match = /(?:youtube(?:-nocookie)?\.com\/(?:embed\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/.exec(blok.url ?? '')
    return match?.[1]
})

// YT.PlayerState.PLAYING === 1; fired on click-autoplay, now the real "viewed".
function onStateChange(event) {
    if (event.data === 1)
        capture('video_viewed', { title: blok.title, url: blok.url })
}
</script>

<style lang="scss">
@use 'youtube-embed';
</style>
